export default __webpack_public_path__ + "static/media/milestone 200.44727707.svg";